// extracted by mini-css-extract-plugin
export default {"accordian":"accordian_accordian__i4F7-"};